import { mdiEyeOutline } from "@mdi/js"
import type { KehrblattCaseCommunicationAutomationContext } from "../../../../../../../../api/kehrblatt/case-communications"
import type { ContactOrderStep } from "../../../../../../../../api/kehrblatt/contact-orders"
import type { ContactOrderPlanRow } from "../../../_logic/communication-plan-table-contract"
import { resolveWerkAdminTarget } from "../_logic/werkAdminTarget"
import type { TableRowAction } from "@kontextwerk/web-sdk/core/layout/table"

export default function buildRowActions({
  row,
  step = null,
  automationContext = null,
  organizationSlug = null,
  voiceLikeChannels,
  allowed,
}: {
  row: ContactOrderPlanRow
  step?: ContactOrderStep | null
  automationContext?: KehrblattCaseCommunicationAutomationContext | null
  organizationSlug?: string | null
  voiceLikeChannels: Set<string>
  allowed: boolean
}): TableRowAction[] {
  const werkTargets = resolveWerkAdminTarget({ step, automationContext, organizationSlug })
  const openWerkAdminForStep = () => {
    const url = werkTargets.sessionUrl || werkTargets.fallbackUrl

    if (url && typeof window !== "undefined") {
      window.open(url, "_blank", "noopener,noreferrer")
    }
  }
  const actions: TableRowAction[] = []

  if (
    allowed &&
    voiceLikeChannels.has((row.channel || "").toUpperCase()) &&
    (werkTargets.sessionUrl || werkTargets.fallbackUrl)
  ) {
    actions.push({
      id: "action-0",

      label: werkTargets.sessionUrl
        ? "Werk-Admin: Session anzeigen."
        : "Werk-Admin: neue Session öffnen.",
      onClick: () => openWerkAdminForStep(),
      icon: mdiEyeOutline,
      tooltip: werkTargets.sessionUrl
        ? "Werk-Admin: Session anzeigen."
        : "Werk-Admin: neue Session öffnen.",
    })
  }

  return actions
}
